/* fullr – Interaktionen (vanilla, ohne Abhängigkeiten) */
(function () {
  document.documentElement.classList.add('fr-js');
  var d = document, $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(cents, tpl) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    var parts = v.split(','); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    v = parts.join(',');
    return (tpl || 'VAL €').replace('VAL', v);
  }

  /* Reveal */
  function reveal() {
    var els = $$('.fr-rv:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Galerie */
  function gallery(root) {
    var main = root.querySelector('.fr-gal__main'); if (!main) return;
    var slides = $$('.fr-gal__slide', main), thumbs = $$('.fr-gal__thumbs button', root), dots = $$('.fr-gal__dots i', root);
    function set(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var th = thumbs[i]; if (th) { var pr = th.parentNode.getBoundingClientRect(), tr = th.getBoundingClientRect(); if (tr.left < pr.left || tr.right > pr.right) th.parentNode.scrollBy({ left: tr.left - pr.left - 8, behavior: reduce ? 'auto' : 'smooth' }); }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { main.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); set(i); }); });
    var tm; main.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { set(Math.round(main.scrollLeft / main.clientWidth)); }, 60); }, { passive: true });
  }

  /* Kaufbox: Pakete, Abo/Einmalkauf, Kit, Lieferdatum, Sticky */
  function buybox(root) {
    var form = root.querySelector('form[data-fr-buy]'); if (!form) return;
    var pct = parseFloat(root.getAttribute('data-abo-pct') || '0');
    var tpl = root.getAttribute('data-money') || 'VAL €';
    var abo = form.querySelector('[data-fr-abo]');
    var kitIn = form.querySelector('[data-fr-kit-input]');
    var kitOut = root.querySelector('[data-fr-kit-out]');
    var otBtn = form.querySelector('[data-fr-ot]');
    var otPrice = form.querySelector('[data-fr-ot-price]');
    var kauf = $$('[data-fr-kauf]', form);
    kauf.forEach(function (r) { r.addEventListener('change', function () { if (abo && r.checked) abo.checked = r.value === 'abo'; }); });
    var kauf = $$('[data-fr-kauf]', form);
    kauf.forEach(function (r) { r.addEventListener('change', function () { if (abo && r.checked) abo.checked = r.value === 'abo'; }); });
    /* v2.16e: Abo-Kasten (Häkchen) steuert das Abo */
    var abocb = $$('[data-fr-abocb]', form);
    abocb.forEach(function (c) { c.addEventListener('change', function () { if (abo) abo.checked = c.checked; }); });
    var stName = d.querySelector('[data-fr-st-name="' + root.id + '"]');
    var stBtn = d.querySelector('[data-fr-sticky="' + root.id + '"] button');
    /* v2.13: Vorauswahl aus dem Presell (?abo=0 · ?zubuchung=serum,shampoo) */
    try {
      var qs = new URLSearchParams(location.search);
      if (abo && qs.get('abo') === '0') abo.checked = false;
      if (abo && qs.get('abo') === '1') abo.checked = true;
      (qs.get('zubuchung') || '').split(',').forEach(function (k) { k = k.trim(); if (!k) return; var cb = form.querySelector('[data-fr-addon][data-key="' + k + '"]'); if (cb) cb.checked = true; });
    } catch (e) {}
    var stPrice = d.querySelector('[data-fr-st-price="' + root.id + '"]');
    var xs = $$('.fr-tier--x', form);
    var base = 0;
    xs.forEach(function (t) { if (t.hasAttribute('data-nobase')) return; var p = +t.getAttribute('data-price'), dd = +t.getAttribute('data-days') || 30; base = Math.max(base, Math.round(p * 30 / dd)); });
    function eff(p, on) { return on ? Math.round(p * (1 - pct / 100)) : p; }
    function upd() {
      var on = !!(abo && abo.checked);
      if (xs.length || kauf.length || abocb.length) { root.classList.toggle('is-abo', on); root.classList.toggle('is-ot', !on); }
      kauf.forEach(function (r) { r.checked = (r.value === 'abo') === on; });
      abocb.forEach(function (c) { c.checked = on; var bx = c.closest('[data-fr-abox]'); if (bx) bx.classList.toggle('is-on', on); });
      $$('.fr-tier', form).forEach(function (t) {
        var p = parseInt(t.getAttribute('data-price'), 10), days = parseInt(t.getAttribute('data-days') || '0', 10);
        var e = eff(p, on);
        if (t.classList.contains('fr-tier--x')) {
          var inp = t.querySelector('input[name="id"]');
          var dd = days || 30, pm = Math.round(e * 30 / dd), pdv = Math.round(e / dd);
          var save = base ? Math.round((1 - pm / base) * 100) : 0;
          var q = function (s) { return t.querySelector(s); };
          if (q('[data-fr-pm]')) q('[data-fr-pm]').textContent = fmt(pm, tpl);
          if (q('[data-fr-pd]')) q('[data-fr-pd]').textContent = fmt(pdv, tpl) + ' am Tag';
          if (q('[data-fr-bill]')) q('[data-fr-bill]').textContent = fmt(e, tpl) + ' ' + (on ? (inp.getAttribute('data-plan-label') || '') : 'einmalig');
          var sv = q('[data-fr-save]'); if (sv) { sv.textContent = 'Spare ' + save + ' %'; sv.hidden = save < 1; }
          t.classList.toggle('is-sel', !!(inp && inp.checked));
        } else {
          var b = t.querySelector('[data-fr-p]'); if (b) b.textContent = fmt(e, tpl);
          var bw = t.querySelector('[data-fr-p-was]'); if (bw) bw.textContent = fmt(p, tpl);
          var pd = t.querySelector('[data-fr-pd]'); if (pd && days) pd.textContent = fmt(Math.round(e / days), tpl) + ' / Tag';
        }
      });
      var sel = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!sel) return;
      var card = sel.closest('.fr-tier');
      var sp = parseInt(sel.getAttribute('data-price'), 10), sd = parseInt(sel.getAttribute('data-days') || '0', 10);
      if (abo && sel.getAttribute('data-plan')) { abo.value = sel.getAttribute('data-plan'); $$('[data-fr-abo-label]', root).forEach(function (al) { al.textContent = sel.getAttribute('data-plan-label') || ''; }); }
      if (otPrice) otPrice.textContent = fmt(sp, tpl);
      $$('[data-fr-k-abo]', form).forEach(function (x) { x.textContent = fmt(eff(sp, true), tpl); });
      $$('[data-fr-k-ot],[data-fr-k-was]', form).forEach(function (x) { x.textContent = fmt(sp, tpl); });
      $$('[data-fr-k-abo]', form).forEach(function (x) { x.textContent = fmt(eff(sp, true), tpl); });
      $$('[data-fr-k-ot],[data-fr-k-was]', form).forEach(function (x) { x.textContent = fmt(sp, tpl); });
      $$('[data-fr-abo-price]', root).forEach(function (x) { x.textContent = fmt(eff(sp, true), tpl); });
      $$('[data-fr-abox-save]', form).forEach(function (x) { x.textContent = fmt(sp - eff(sp, true), tpl); });
      /* v2.11: Zubuchung (z. B. Serum zur Kapsel-Kur) nur ab Paketgröße X */
      $$('[data-fr-addon-wrap]', root).forEach(function (w) {
        var cb = w.querySelector('[data-fr-addon]'), ok = sd >= (+w.getAttribute('data-min-days') || 0) && !sel.hasAttribute('data-no-addon'); w.hidden = sel.hasAttribute('data-no-addon');
        w.classList.toggle('is-off', !ok); if (cb) { cb.disabled = !ok; if (!ok) cb.checked = false; }
        w.classList.toggle('is-on', !!(cb && cb.checked));
      });
      /* v2.13 */
      $$('[data-fr-best-note]', root).forEach(function (x) { x.hidden = !sel.hasAttribute('data-no-addon'); });
      $$('[type="submit"][name="add"]', form).concat(stBtn ? [stBtn] : []).forEach(function (b) {
        if (!b.hasAttribute('data-cta0')) b.setAttribute('data-cta0', b.innerHTML);
        var c = sel.getAttribute('data-cta'), sub = b.querySelector('.fr-btn__sub'), subH = sub ? sub.outerHTML : '';
        b.innerHTML = c ? c + (b === stBtn ? '' : (subH || ' →')) : b.getAttribute('data-cta0');
      });
      var kit = sel.getAttribute('data-kit') || '';
      if (kitIn) { kitIn.value = kit; kitIn.disabled = !kit; }
      if (kitOut) { kitOut.textContent = kit; kitOut.closest('.fr-kit').hidden = !kit; }
      if (stName) stName.textContent = (sel.getAttribute('data-name') || '') + ((xs.length || kauf.length || abocb.length) && on ? ' · im Abo' : '');
      if (stPrice) {
        var e2 = eff(sp, on);
        stPrice.textContent = (xs.length && sd) ? fmt(Math.round(e2 / sd), tpl) + ' am Tag · ' + fmt(e2, tpl) + ' ' + (on ? (sel.getAttribute('data-plan-label') || '') : 'ohne Abo') : fmt(e2, tpl);
      }
      if (card && sel.getAttribute('data-media')) {
        var m = root.querySelector('.fr-gal__slide[data-media="' + sel.getAttribute('data-media') + '"]');
        if (m) m.parentNode.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', sel.value); history.replaceState(null, '', u); } catch (e) {}
    }
    if (otBtn && abo) otBtn.addEventListener('click', function () { abo.checked = !abo.checked; upd(); });
    form.addEventListener('change', upd); upd();
    /* Lieferdatum: heute + min/max Werktage */
    $$('[data-fr-ship]', root).forEach(function (el) {
      var out = el.querySelector('[data-fr-ship-out]'); if (!out) return;
      function add(n) { var x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
      try {
        var o = { weekday: 'short', day: 'numeric', month: 'short' };
        var a1 = add(+el.getAttribute('data-min') || 8).toLocaleDateString('de-DE', o), a2 = add(+el.getAttribute('data-max') || 10).toLocaleDateString('de-DE', o);
        out.textContent = 'Lieferung voraussichtlich ' + a1 + ' – ' + a2;
      } catch (e) {}
    });
    var sticky = d.querySelector('[data-fr-sticky="' + root.id + '"]');
    var btn = form.querySelector('[type="submit"]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { sticky.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(btn);
    }
  }

  /* Mechanismus-Ebenen */
  function layers(root) {
    var ls = $$('.fr-layer', root), imgs = $$('[data-layer-img]', root);
    function on(i) { ls.forEach(function (l, k) { l.classList.toggle('is-on', k === i); l.setAttribute('aria-pressed', String(k === i)); }); imgs.forEach(function (m) { m.hidden = String(i) !== m.getAttribute('data-layer-img') && imgs.length > 1 && m.getAttribute('data-layer-img') !== 'all'; }); }
    ls.forEach(function (l, i) { l.addEventListener('click', function () { on(i); }); });
  }

  /* Inhaltsstoffe */
  function orch(root) {
    var bs = $$('.fr-orch button', root), out = root.querySelector('.fr-orch-out');
    function on(b) {
      bs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      out.innerHTML = ''; var h = d.createElement('h3'); h.textContent = b.getAttribute('data-name');
      var dose = b.getAttribute('data-dose'); if (dose) { var s = d.createElement('small'); s.textContent = dose; h.appendChild(s); }
      var p = d.createElement('p'); p.textContent = b.getAttribute('data-text'); out.appendChild(h); out.appendChild(p);
    }
    bs.forEach(function (b) { b.addEventListener('click', function () { on(b); }); }); if (bs[0]) on(bs[0]);
  }

  /* Feed: Kommentare erscheinen nacheinander */
  function feed(root) {
    var cms = $$('.fr-cm', root); if (!cms.length) return;
    if (reduce || !('IntersectionObserver' in window)) { cms.forEach(function (c) { c.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cms.forEach(function (c, i) { setTimeout(function () { c.classList.add('is-in'); }, 350 + i * 650); }); } }, { threshold: .2 });
    io.observe(root);
  }

  /* Warte-Zähler */
  function counter(el) {
    var to = parseInt(el.getAttribute('data-to') || '84', 10);
    if (reduce || !('IntersectionObserver' in window)) { el.textContent = to; return; }
    var io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting) return; io.disconnect(); var t0 = null;
      function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1600); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step); }, { threshold: .4 });
    io.observe(el);
  }

  function init(scope) {
    scope = scope || d;
    $$('[data-fr-gallery]', scope).forEach(gallery);
    $$('[data-fr-buybox]', scope).forEach(buybox);
    $$('[data-fr-layers]', scope).forEach(layers);
    $$('[data-fr-orch]', scope).forEach(orch);
    $$('[data-fr-feed]', scope).forEach(feed);
    $$('[data-fr-counter]', scope).forEach(counter);
    $$('.fr-flip', scope).forEach(function (f) { f.addEventListener('click', function () { f.setAttribute('aria-pressed', String(f.getAttribute('aria-pressed') !== 'true')); }); });
    reveal();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
